import React from "react"

import BrokerGuidancePanel from "./BrokerGuidancePanel"
import {
  ChecklistRow,
  GuidanceAccordionBody,
  GuidanceBlock,
  GuidanceIntro,
} from "./ibkrGuidanceShared"

export interface Mt4StatementImportGuidanceProps {
  compact?: boolean
}

const Mt4StatementImportGuidance = ({
  compact = false,
}: Mt4StatementImportGuidanceProps): React.ReactElement => {
  return (
    <BrokerGuidancePanel title="How to export your MT4 Detailed Report" compact={compact} collapsible>
      <GuidanceAccordionBody>
        <GuidanceIntro className="!mb-0">
          In MetaTrader 4, export a Detailed Report as HTML (.htm or .html). Tessera reads closed
          buy/sell rows and ignores balance or deposit rows.
        </GuidanceIntro>

        <GuidanceBlock title="Export steps">
          <ChecklistRow className="!mb-0">
            Export a Detailed Report as HTML (.htm or .html)
          </ChecklistRow>
          <ChecklistRow className="!mb-0">Upload the downloaded report here</ChecklistRow>
        </GuidanceBlock>

        <GuidanceBlock title="Things to know">
          <ChecklistRow className="!mb-0">
            The account number is read from the report header (Account:). You do not enter it on
            import. Use the same report type each time so Tessera can merge trades for that account.
          </ChecklistRow>
          <ChecklistRow className="!mb-0">
            Select the timezone that matches the timestamps shown in the report. MT4 report times
            are usually broker server time, not necessarily your local clock.
          </ChecklistRow>
          <ChecklistRow className="!mb-0">
            Commission, taxes, and swap are imported when present. If those columns are missing,
            they default to zero.
          </ChecklistRow>
        </GuidanceBlock>
      </GuidanceAccordionBody>
    </BrokerGuidancePanel>
  )
}

export default Mt4StatementImportGuidance
